<script setup lang="ts">
import Codemirror from "codemirror-editor-vue3";

import "codemirror/addon/display/placeholder.js";
import "codemirror/theme/dracula.css";
import { ref } from "vue";

const emit = defineEmits(["update:inputCode"]);
const props = defineProps({
  codeInput: {
    type: String,
    default: "",
  },
  height: {
    type: Number,
    default: 300,
  },
  placeholder: {
    type: String,
    default: "Add your code here",
  },
  editorOptions: {
    type: Object,
    default() {
      return {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: "text/html",
        lineWrapping: true,
        theme: "dracula",
      };
    },
  },
});

const inputCode = ref(props.codeInput || "");

const inputEvent = (input: string) => {
  emit("update:inputCode", input);
};
</script>

<template>
  <div :style="{ height: height + 'px' }" class="hl-custom-code-editor w-full">
    <Codemirror
      ref="myCm"
      v-model:value="inputCode"
      class="rounded-md text-left"
      :placeholder="placeholder"
      :options="props.editorOptions"
      @input="inputEvent"
    />
  </div>
</template>

<style>
.hl-custom-code-editor .CodeMirror,
.CodeMirror-merge-pa {
  font-family: monospace !important;
}

.hl-custom-code-editor .CodeMirror-gutter-wrapper .CodeMirror-linenumber {
  position: static;
}

.codemirror-container {
  font-size: 15px;
}
</style>
